import { render, staticRenderFns } from "./NotWorking.vue?vue&type=template&id=f4b67c9e&"
import script from "./NotWorking.vue?vue&type=script&lang=js&"
export * from "./NotWorking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports